
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ColorQuestionAnswerResult,
  CandidateResult,
  ColorAnswer
} from "@/lib/model/exam/result";

@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) all!: CandidateResult;
  @Prop({ default: false }) isH5!: boolean;
  @Prop({ default: false }) inReport!: boolean;
  @Prop({ default: false }) pdfIng!: boolean;

  isShowMore = false;

  //色盲题结构
  get getColorTestQuestion(): ColorQuestionAnswerResult {
    return (
      this.all.answerList.find(item => item.type === 102)
        ?.colorQuestionAnswerResult || new ColorQuestionAnswerResult()
    );
  }
  //细分类型 变更 不分类型了
  questionListByType(): ColorAnswer[] {
    if (this.isShowMore) {
      return this.getColorTestQuestion.colorAnswerList;
    } else {
      return this.getColorTestQuestion.colorAnswerList.slice(0, 4);
    }
  }

  created() {
    //
  }
  mounted() {
    if (this.getColorTestQuestion.colorAnswerList.length <= 4) {
      this.isShowMore = true;
    }
  }

  @Watch("pdfIng")
  handlePdfIng(newVal: boolean) {
    this.isShowMore = newVal;
  }
}
